/* assets/int-variant-gallery.js
   Moved out of snippets/int-variant-gallery.liquid on 2026-09-10 to cut the PDP HTML
   payload. It rendered as a 19,017 byte inline <script> block. Its four Liquid built maps
   (VAR_COLOR, VAR_HERO, MEDIA_COLOR, INITIAL_VARIANT) now arrive as JSON in #int-vg-data.
   ⛔ PLAIN <script src>, NOT defer, at the exact position the inline block held. The
   window.__intVGInit guard is kept, so a double include is still a no-op.
   MEDIA_COLOR is still the longest-match-on-alt join CLAUDE.md describes; the matching is
   still done in Liquid in the island, not in JS. */

(function () {
  if (window.__intVGInit) return;
  window.__intVGInit = true;

  /* 2026-09-10 PDP PAYLOAD: these four values were built by Liquid right here and were the
     only Liquid in this block. They now arrive as JSON in #int-vg-data, written by the
     snippet immediately above the <script src>. Shapes are identical. */
  var _D = {};
  try { _D = JSON.parse(document.getElementById('int-vg-data').textContent); } catch (e) { _D = {}; }
  var VAR_COLOR = _D.varColor || {};
  var VAR_HERO = _D.varHero || {};
  var MEDIA_COLOR = _D.mediaColor || {};
  var INITIAL_VARIANT = String(_D.initialVariant || '');
  /* INT 2026-10-09 SHARED GALLERY ITEMS (gallery-shared-media). A picture or film listed in the
     product metafield custom.gallery_shared shows in EVERY colour (MEDIA_COLOR ""), at its own slot:
     SHARED_SLOT maps its slide id to a 1-based position (2 or higher, 1 is always the hero).
     sections/product.liquid already renders it at that slot for the colour the page opens on, so on
     load the order below matches the DOM and nothing moves. On a colour change it is kept in the
     gallery (never re-appended, which would leave two Flickity cells on one element and remove it with
     the old colour) and moved to the same slot, and its thumbnail follows. */
  var SHARED_SLOT = _D.sharedSlot || {};
  function hasSlot(id) { return Object.prototype.hasOwnProperty.call(SHARED_SLOT, id); }
  function placeShared(list) {
    var rest = [], sh = [];
    list.forEach(function (s) { (hasSlot(s.id) ? sh : rest).push(s); });
    if (!sh.length) return list;
    sh.sort(function (a, b) { return SHARED_SLOT[a.id] - SHARED_SLOT[b.id]; });
    sh.forEach(function (s) {
      var i = Math.max(1, Math.min((parseInt(SHARED_SLOT[s.id], 10) || 3) - 1, rest.length));
      rest.splice(i, 0, s);
    });
    return rest;
  }
  /* Put the cells in exactly the order of want (elements). ⛔ Not with flkty.remove()/insert(): on
     this theme remove() throws inside the fade code (fadeSlides, "setOpacity of undefined") after it has
     already taken the element out of the page, so the shared slide was lost on every second colour
     change (measured 2026-10-09). Instead the slides are moved in the page and Flickity re-reads them,
     the same reloadCells path int-gs-main.js uses. Only misplaced slides move; in order, nothing does. */
  function orderCells(flkty, want) {
    var cur = flkty.getCellElements();
    var same = cur.length === want.length;
    for (var i = 0; same && i < want.length; i++) { if (cur[i] !== want[i]) same = false; }
    if (same || !want.length || typeof flkty.reloadCells !== 'function') return;
    var slider = cur.length ? cur[0].parentNode : want[0].parentNode;
    if (!slider) return;
    for (var k = 0; k < want.length; k++) {
      if (want[k].parentNode !== slider || slider.children[k] !== want[k]) slider.insertBefore(want[k], slider.children[k] || null);
    }
    flkty.reloadCells();
    if (typeof flkty.resize === 'function') flkty.resize();
  }
  /* The phone dot row (.int-mob-dots, built by assets/int-pdp-mobile.js) is counted once, on
     int:gallery:settled and on resize, so it kept the old colour's count after a colour change
     (wrong already when colours differ in count, and every time with shared items). Recount it here
     with the same markup; its click and select handlers are delegated and keep working. */
  function syncMobDots(flkty) {
    var box = document.querySelector('.int-mob-dots');
    if (!box || !flkty || !flkty.cells) return;
    var n = flkty.cells.length;
    if (n < 2) { box.hidden = true; return; }
    box.hidden = false;
    if (box.children.length !== n) {
      box.textContent = '';
      for (var i = 0; i < n; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'int-mob-dot';
        d.setAttribute('aria-label', 'Photo ' + (i + 1));
        d.dataset.i = String(i);
        box.appendChild(d);
      }
    }
    for (var j = 0; j < box.children.length; j++) box.children[j].classList.toggle('is-on', j === flkty.selectedIndex);
  }
  /* Move each shared thumbnail in front of the thumbnail of the slide that follows it. */
  function placeSharedThumbs(desired) {
    if (!desired.some(function (s) { return hasSlot(s.id); })) return;
    var byId = {};
    THUMBS.forEach(function (t) { if (!byId[t.id]) byId[t.id] = t.el; });
    for (var k = desired.length - 1; k >= 0; k--) {
      if (!hasSlot(desired[k].id)) continue;
      var t = byId[desired[k].id];
      if (!t) continue;
      var next = null, prev = null, j;
      for (j = k + 1; j < desired.length && !next; j++) next = byId[desired[j].id] || null;
      if (next) {
        if (t.nextElementSibling !== next && next.parentNode) next.parentNode.insertBefore(t, next);
        continue;
      }
      for (j = k - 1; j >= 0 && !prev; j--) prev = byId[desired[j].id] || null;
      if (prev && prev.nextElementSibling !== t && prev.parentNode) prev.parentNode.insertBefore(t, prev.nextSibling);
    }
  }

  /* ---------------- helpers ---------------- */
  function Flk() {
    var F = window.Flickity || (window.themeVendor && window.themeVendor.Flickity);
    return (F && F.data) ? F : null;
  }
  var SS = document.querySelector('[data-product-slideshow]');

  var ALL = [];   /* {id, el} every slide, original order */
  function cacheSlides() {
    if (ALL.length || !SS) return;
    SS.querySelectorAll('[data-media-slide]').forEach(function (el) {
      ALL.push({ id: String(el.getAttribute('data-media-id')), el: el });
    });
  }
  var THUMBS = [];
  function cacheThumbs() {
    if (THUMBS.length) return;
    document.querySelectorAll('[data-slideshow-thumbnail]').forEach(function (el) {
      THUMBS.push({ id: String(el.getAttribute('data-media-select')), el: el });
    });
  }
  function currentVariantId() {
    var p = new URLSearchParams(window.location.search);
    return p.get('variant') || INITIAL_VARIANT;
  }
  function showSet(color) {
    var s = {};
    for (var id in MEDIA_COLOR) {
      var mc = MEDIA_COLOR[id];
      if (mc === '' || mc === color) s[id] = true;
    }
    return s;
  }

  var lastVariant = null;
  var pending = null;

  function doApply(variantId) {
    var color = VAR_COLOR[String(variantId)];
    if (color == null) return;
    cacheSlides();
    cacheThumbs();
    if (!ALL.length) return;

    var F = Flk();
    var flkty = F ? F.data(SS) : null;
    if (!flkty) { pending = variantId; armReady(); return; }  /* wait for Flickity */

    var show = showSet(color);
    var heroId = String(VAR_HERO[String(variantId)] || '');

    /* desired = matching slides, hero first, rest in original order */
    var desired = ALL.filter(function (s) { return show[s.id]; });
    if (!desired.length) return;                         /* never empty the gallery */
    desired.sort(function (a, b) {
      if (a.id === heroId) return -1;
      if (b.id === heroId) return 1;
      return 0;
    });
    desired = placeShared(desired);

    /* CRITICAL: clear any stale inline display on every slide so re-added
       cells are never stuck hidden (Flickity.append won't clear it). */
    ALL.forEach(function (s) { s.el.style.display = ''; });

    try {
      var current = flkty.getCellElements().slice();
      var desiredEls = desired.map(function (s) { return s.el; });
      var heroEl = desiredEls[0];

      if (current.indexOf(heroEl) !== -1) {
        /* INITIAL / rebuild: the colour's cells are already in the gallery
           (e.g. first load with all cells present) — just drop the rest. */
        var toRemove = current.filter(function (el) { return desiredEls.indexOf(el) === -1; });
        try { if (toRemove.length) flkty.remove(toRemove); } catch (e1) { if (window.console) console.warn('[int-vg] remove', e1); }
        try { orderCells(flkty, desiredEls); } catch (e2) { if (window.console) console.warn('[int-vg] order', e2); }  /* no-op when the server order is right */
        flkty.select(0, false, true);
      } else {
        /* SWITCH: append the new colour's cells, show its hero, THEN remove
           the old cells — so the gallery never goes blank (no white flash).
           INT 2026-10-09: cells that belong to every colour (shared items, media of no colour) are
           already in the gallery, so they are kept, not appended again, then moved to their place. */
        var kept = desiredEls.filter(function (el) { return current.indexOf(el) !== -1; });
        var added = desiredEls.filter(function (el) { return current.indexOf(el) === -1; });
        flkty.append(added);
        flkty.select(current.length, false, true);  /* new hero (appended at end) */
        var gone = current.filter(function (el) { return kept.indexOf(el) === -1; });
        try { if (gone.length) flkty.remove(gone); } catch (e1) { if (window.console) console.warn('[int-vg] remove', e1); }  /* drop old colour */
        try { orderCells(flkty, desiredEls); } catch (e2) { if (window.console) console.warn('[int-vg] order', e2); }
        flkty.select(0, false, true);                /* new hero now at index 0 */
      }
      flkty.resize();                 /* settle fade layout */
    } catch (e) { if (window.console) console.warn('[int-vg]', e); }

    /* thumbnails: show only matching */
    /* The theme sets .media__thumb { display: block !important } above 768px, so a
       plain inline display loses to it and this line was a no-op on desktop while
       working on mobile. Same treatment as int-variant-gallery-framed.liquid. */
    THUMBS.forEach(function (t) {
      if (show[t.id]) { t.el.style.removeProperty('display'); }
      else { t.el.style.setProperty('display', 'none', 'important'); }
    });
    placeSharedThumbs(desired);
    syncMobDots(flkty);
    var TS = document.querySelector('[data-product-thumbs-slider]');
    if (F && TS) { var tf = F.data(TS); if (tf && tf.reloadCells) { tf.reloadCells(); if (tf.resize) tf.resize(); } }

    lastVariant = String(variantId);
  }

  function applyVariant(variantId, force) {
    if (!force && String(variantId) === lastVariant) return;
    doApply(variantId);
  }

  /* ---------------- ready handling ---------------- */
  var readyTimer = null, tries = 0;
  function armReady() {
    if (readyTimer) return;
    readyTimer = setInterval(function () {
      var F = Flk();
      if (F && SS && F.data(SS)) {
        clearInterval(readyTimer); readyTimer = null;
        doApply(pending || currentVariantId());
        pending = null;
      } else if (tries++ > 80) {        /* ~8s safety */
        clearInterval(readyTimer); readyTimer = null;
      }
    }, 100);
  }

  /* ---------------- events ---------------- */
  function onVariantEvent(e) {
    var v = e && e.detail && e.detail.variant;
    applyVariant(v && v.id ? v.id : currentVariantId());
  }
  document.addEventListener('variant:change', onVariantEvent);
  document.addEventListener('theme:variant:change', onVariantEvent);

  /* Warm every colour's hero image on idle, so the first swatch tap shows an
     already-cached image instead of waiting for a download (esp. on mobile).

     INT 2026-08-10 — this was pulling the full-size file for every colour.
     Measured on a cold PDP load: seven requests all starting at 2672ms,
     width=3000 each, 218-342KB, about 1.26MB. Two things were wrong.

     First, it set pre.src to the img's src attribute, and that attribute is
     the un-negotiated fallback — the largest candidate. Setting .sizes and
     .srcset beforehand did not save it; a detached Image() given an explicit
     src fetches that src.

     Second, and worse, the damage did not stop at the preloads. Once a 3000w
     file is in the cache the browser is entitled to prefer it when picking a
     candidate for the slides too, so the visible gallery quietly upgraded
     itself to 3000w as well and the sizes attribute stopped mattering.

     So work out the width the way the browser would, from the real box and
     the real pixel ratio, and ask for that. Nothing else about the warm-up
     changes: same images, same idle timing, same purpose. */
  var _preloaded = false;

  /* smallest srcset candidate that still covers the box; null if no srcset */
  function pickCandidate(img, wantPx) {
    var ss = img.getAttribute('srcset');
    if (!ss) return null;
    var best = null, bestW = Infinity, biggest = null, biggestW = 0;
    ss.split(',').forEach(function (part) {
      var bits = part.trim().split(/\s+/);
      var url = bits[0];
      var w = parseInt(bits[1], 10);
      if (!url || !w) return;
      if (w > biggestW) { biggestW = w; biggest = url; }
      if (w >= wantPx && w < bestW) { bestW = w; best = url; }
    });
    return best || biggest;   /* nothing big enough: the largest is the best we have */
  }

  function preloadHeroes() {
    if (_preloaded) return;
    cacheSlides();
    if (!ALL.length) return;
    _preloaded = true;

    /* Ask for exactly the file the slides themselves are using, not merely a
       big-enough one. First attempt computed box x DPR = 928 and picked the
       932w candidate, while the slides' own sizes attribute resolved to 1024w
       — so the warm-up downloaded five images that were never going to be
       reused. Read the width the browser already settled on for the visible
       hero and match it; fall back to the measurement only if nothing has
       resolved yet. */
    var ref = SS && (SS.querySelector('[data-media-slide].is-selected img')
                     || SS.querySelector('[data-media-slide] img'));
    var rm = ref && ref.currentSrc && ref.currentSrc.match(/[?&]width=(\d+)/);
    var want;
    if (rm) {
      want = parseInt(rm[1], 10);
    } else {
      var box = SS ? Math.round(SS.getBoundingClientRect().width) : 0;
      if (!box) box = Math.min(window.innerWidth || 500, 500);
      want = Math.round(box * (window.devicePixelRatio || 1));
    }

    var seen = {};
    for (var vid in VAR_HERO) { seen[String(VAR_HERO[vid])] = 1; }
    ALL.forEach(function (s) {
      if (!seen[s.id]) return;
      var img = s.el.querySelector('img');
      if (!img) return;
      var url = pickCandidate(img, want);
      if (!url) {
        /* no srcset to choose from — take the src but pull its width down to
           what is actually needed rather than fetching the original */
        url = img.getAttribute('src');
        if (!url) return;
        url = url.replace(/([?&]width=)\d+/, '$1' + want);
      }
      var pre = new Image();
      pre.src = url;   /* fetches into the browser cache */
    });
  }
  function schedulePreload() {
    if (window.requestIdleCallback) requestIdleCallback(preloadHeroes, { timeout: 2500 });
    else setTimeout(preloadHeroes, 1200);
  }

  /* initial filter */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { applyVariant(currentVariantId(), true); schedulePreload(); });
  } else {
    applyVariant(currentVariantId(), true);
    schedulePreload();
  }
})();
